import { AppStore } from '../Core/AppStore';
import { AuditStore } from '../Audit/AuditStore';
import {
    CommonAppStore,
    ErrorStore,
    HttpClient,
    PowerBIStore,
    TasksStore,
    TicketsStore,
    TooltipsStore,
} from 'Mri.Web.Common';
import { DisplayFiltersStore } from '../DisplayFilters/DisplayFiltersStore';
import { DisplaysStore } from '../Displays/DisplaysStore';
import { UnitsStore } from '../Units/UnitsStore';
import { AccountsStore } from '../Accounts/AccountsStore';
import { ContractsStore } from '../Contracts/ContractsStore';
import { WeatherStore } from '../Weather/WeatherStore';
import { WarrantyAlertsStore } from '../WarrantyAlerts/WarrantyAlertsStore';
import { UserManagerSettings } from 'oidc-client';
import { AccountStore } from '../Account/AccountStore';
import {DisplaysChartsStore} from "../Displays/DisplaysChartsStore";
import {cloneDeep} from "lodash";
import {runInAction, toJS} from "mobx";
import {diff} from "deep-diff";

const httpClient = new HttpClient();
const initialOidcConfig = (window as any).initialOidcConfig as UserManagerSettings;
const accountStore = new AccountStore(httpClient, initialOidcConfig);
const appStore = new AppStore();

setupStorageSync(accountStore, appStore);

httpClient.setAccessTokenStore(accountStore);
export const stores = {
    accountStore,
    appStore,
    auditStore: new AuditStore(httpClient),
    commonAppStore: new CommonAppStore(httpClient),
    displayFiltersStore: new DisplayFiltersStore(httpClient),
    displaysStore: new DisplaysStore(httpClient, accountStore),
    displaysChartsStore: new DisplaysChartsStore(httpClient),
    errorStore: new ErrorStore(httpClient),
    powerBIStore: new PowerBIStore(httpClient),
    unitsStore: new UnitsStore(httpClient),
    ticketsStore: new TicketsStore(httpClient, (window as any).initialFieldIds),
    tasksStore: new TasksStore(httpClient, accountStore),
    accountsStore: new AccountsStore(httpClient),
    contractsStore: new ContractsStore(httpClient),
    tooltipsStore: new TooltipsStore(httpClient),
    weatherStore: new WeatherStore(httpClient),
    warrantyAlertsStore: new WarrantyAlertsStore(httpClient),
};

function setupStorageSync(accountStore: AccountStore, appStore: AppStore) {
    window.addEventListener('storage', (event) => {
        // Prevents updates if it is the active tab
        if (document.hasFocus() || document.visibilityState === 'visible') {
            return;
        }


        if (event.key === 'AccountStore.AccountStorage' && event.newValue) {
            try {
                const newStorage = JSON.parse(event.newValue);
                const oldStorage = cloneDeep(toJS(accountStore.storage)); // snapshot before update

                runInAction(() => {
                    accountStore.suppressStorageSync = true;
                    Object.assign(accountStore.storage, newStorage);
                    queueMicrotask(() => {
                        accountStore.suppressStorageSync = false;
                    });
                });

                // Log granular differences
                setTimeout(() => {
                    const updatedStorage = toJS(accountStore.storage);
                    const differences = diff(oldStorage, updatedStorage);

                    if (differences && differences.length > 0) {
                        console.log("🔍 Detailed storage changes:");
                        differences.forEach(change => {
                            console.log(`• [${change.kind}] ${change.path?.join('.')}:`, change);
                        });
                    } else {
                        console.log("✅ No actual change in storage detected.");
                    }
                }, 0);

            } catch (e) {
                console.error('Failed to sync AccountStore from localStorage:', e);
            }
        }

        if (event.key === 'AppStore.AppStorage' && event.newValue) {
            try {
                const newStorage = JSON.parse(event.newValue);
                if (newStorage.version !== appStore.storage.version) {
                    console.warn('App version mismatch detected. Reloading...');
                    window.location.reload();
                }
            } catch (e) {
                console.error('Failed to sync AppStore from localStorage:', e);
            }
        }
    });
}